<div class="mb-3 has-icon-input-lg shadow">
  <label for="placeInput"
         class="visually-hidden"
         [translate]="'SHARED.PLACES-AUTOCOMPLETE.LABEL'"></label>
  <i-feather name="map-pin"
             class="stroke-navy"></i-feather>
  <input type="text"
         class="form-control form-control-lg border-0 focus-color-navy"
         [(ngModel)]="placeInputValue"
         id="placeInput"
         name="placeInput"
         autocomplete="off"
         autofocus
         placeholder="{{ 'SHARED.PLACES-AUTOCOMPLETE.PLACEHOLDER' | translate }}"
         (keyup)="onPlaceInputKeyup($event)"
         (focus)="onPlaceInputFocus($event)"
         (keydown)="onPlaceInputKeydown($event)"
         (blur)="onPlaceInputBlur()"
         maxlength="50">
  <div class="places-input-container"
       *ngIf="shouldShowResults()"
       on-mouseenter="onResultsMouseEnter()"
       on-mouseleave="onResultsMouseLeave()">
    <ul class="places-input-list">
      <li *ngFor="let item of results; let i = index"
          class="places-input-item notranslate"
          [ngClass]="{'active' : i === activeResultsItemIndex}"
          (click)="placeResultClicked(item)">
        {{ item.city}}
      </li>
    </ul>
    <p class="places-input-attribution text-gray-400"
       [translate]="'SHARED.PLACES-AUTOCOMPLETE.ATTRIBUTION'"></p>
  </div>
</div>
